import {BaseSS} from './BaseSS';

const STORAGE_KEY = 'audioSubTypes';

export class AudioSubTypes extends BaseSS<string> {
  constructor() {
    super(STORAGE_KEY);
  }
}
